import Moment from 'moment'

export default {
  name: 'foot',
  computed: {
    year () {
      return Moment().format('Y')
    },
    isQliroEnabled () {
      const hostname = window.location.hostname.toLowerCase()
      const [ topDomain ] = hostname.match(/(localhost|\.\w{2,4}$)/gm)
      return ['.se'].indexOf(topDomain) > -1 && this.$store.getters.currency.currency === 'SEK'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/foot/script.js